export const fileUploadService = {
    uploadLogo
};

function uploadLogo(file) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return fetch(process.env.VUE_APP_ROOT_API + '/s3/logo/preSignedUrl', requestOptions)
        .then(handleResponse)
        .then(response => {
            let signedUrl = response.content.data;
            let objectKey = response.content.objectKey;
            const fileRequestOptions = {
                method: 'PUT',
                body : file
            };
            return fetch(signedUrl, fileRequestOptions)
                .then(handleResponse)
                .then(()=> {
                    return process.env.VUE_APP_LOGO_BASE_URL + objectKey;
                } );
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return Promise.reject(data);
        }
        return data;
    });
}
